import * as React from 'react';
import moment from 'moment';
import {
  IDataTableButtonProps,
  IDataTableOptionalProps,
  IDataTableRowGroup,
} from '../common/defaults';
import isEqual from 'lodash/isEqual';

//import 'datatables/media/css/jquery.dataTables.css';

import JSZip from 'jszip';
window['JSZip'] = JSZip;

//pdfMake.vfs = pdfFonts.pdfMake.vfs;

const $ = require('jquery');
const dt = require('datatables.net-bs4');
const buttons = require('datatables.net-buttons-bs4');
const rogroup = require('datatables.net-rowgroup-bs4');
const dtSelect = require('datatables.net-select-bs4');
require('datatables.net-buttons/js/buttons.colVis');
require('datatables.net-buttons/js/buttons.html5');
require('datatables.net-buttons/js/buttons.flash');
require('datatables.net-buttons/js/buttons.print');

import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import 'datatables.net-select-dt/css/select.dataTables.css';
import '../assets/Datatable.scss';

export const excludeFromExportClassName = 'excludeFromExport';

interface IDataTableRequiredProps {
  id: string;
  data: any;
  columns: any;
}

interface IDataTableProps
  extends IDataTableRequiredProps,
  IDataTableOptionalProps,
  IDataTableButtonProps { }

export default class DataTable extends React.Component<IDataTableProps, any> {
  el: HTMLTableElement; //| null;
  tableId: string;
  currentTable: any;

  public constructor(props: any) {
    super(props);
    this.tableId = props.id;
  }

  componentDidMount() {
    // This plugin supports date sorting
    $.fn.dataTable.moment = function (format, locale) {
      var types = $.fn.dataTable.ext.type;

      // Add type detection
      types.detect.unshift(function (d) {
        return moment(d, format, locale, true).isValid()
          ? 'moment-' + format
          : null;
      });

      // Add sorting method - use an integer for the sorting
      types.order['moment-' + format + '-pre'] = function (d) {
        return moment(d, format, locale, true).unix();
      };
    };
    // Add moment formats you want to support here (match what the table is formatting)
    $.fn.dataTable.moment('dddd, MMMM Do, YYYY');
    // End plugin
    const exportOptions =
      this.props.actionsColumn && this.props.actionsColumn === 'first'
        ? { columns: 'th:not(:first-child)' }
        : this.props.actionsColumn && this.props.actionsColumn === 'last'
          ? { columns: 'th:not(:last-child)' }
          : null;

    this.currentTable = $('#' + this.tableId).DataTable({
      columns: this.props.columns,
      columnDefs: this.props.columnDefs,
      data: this.props.data || [],
      info: this.props.info !== undefined ? this.props.info : true,
      searching:
        this.props.searching !== undefined ? this.props.searching : true,
      lengthChange:
        this.props.lengthChange !== undefined ? this.props.lengthChange : true,
      pageLength:
        this.props.pageLength !== undefined ? this.props.pageLength : 10,
      order: this.props.order,
      lengthMenu: this.props.lengthMenu !== undefined ? this.props.lengthMenu : [10, 25, 50],
      rowGroup:
        this.props.rowGroup != undefined
          ? { ...(this.props.rowGroup as IDataTableRowGroup) }
          : false,
      orderFixed: this.props.orderFixed,
      select:
        this.props.select !== undefined
          ? this.props.select
          : {
            style: 'multi',
            info:
              this.props.showSelectInfo !== undefined
                ? this.props.showSelectInfo
                : true,
          },
      dom: this.props.dom ? this.props.dom : 'frtipB',
      buttons:
        this.props.dom && this.props.dom.indexOf('B') >= 0
          ? [
            {
              extend: 'pdf',
              className: 'btn btn-primary',
              title: 'CID Data export',
              pageSize: 'A3',
              text: 'PDF',
              exportOptions: exportOptions,
            },
            {
              extend: 'excelHtml5',
              className: 'btn btn-primary',
              title: 'CID Data export',
              text: 'Excel',
              exportOptions: exportOptions,
            },
            {
              extend: 'csvHtml5',
              className: 'btn btn-primary',
              title: 'CID Data export',
              text: 'CSV',
              exportOptions: exportOptions,
            },
            {
              extend: 'print',
              className: 'btn btn-primary',
              title: 'CID Data export',
              text: 'Print',
              exportOptions: exportOptions,
            },
          ]
          : false,
      autoWidth: this.props.autoWidth != undefined ? this.props.autoWidth : true,
      stateSave: this.props.stateSave != undefined ? this.props.stateSave : false,
    });
  }
  componentWillUnmount() {
    if ($('#' + this.tableId).DataTable())
      $('#' + this.tableId)
        .DataTable()
        .destroy(true);
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.data && !isEqual(prevProps.data, this.props.data)) {
      $('#' + this.tableId)
        .DataTable()
        .clear();

      $('#' + this.tableId)
        .DataTable()
        .rows.add(this.props.data);

      $('#' + this.tableId)
        .DataTable()
        .draw(false);
    }

    return false;
  }

  toggleColumnVisibility = (columnNumber: number) => {
    const column = $('#' + this.tableId)
      .DataTable()
      .column(columnNumber);
    column.visible(!column.visible());
  };

  setColumnVisibility = (columnNumber: number, visible: boolean) => {
    const column = $('#' + this.tableId)
      .DataTable()
      .column(columnNumber);
    column.visible(visible);
  };

  getRowsForData = (showOnlySelected?: boolean) => {
    return (showOnlySelected) ? $('#' + this.tableId).DataTable().rows('.selected') : $('#' + this.tableId).DataTable().rows();
  }

  selectAll = (selected?: boolean) => {
    if(selected){
      $('#' + this.tableId).DataTable().rows().select();
    } else {
      $('#' + this.tableId).DataTable().rows().deselect();
    }
  }

  getDataForSelectedRows = () => {
    const table = $('#' + this.tableId).DataTable();
    return table.buttons.exportData(
      table.rows('.selected').indexes().length > 0 ? {
        rows: '.selected',
        columns: `:not(.${excludeFromExportClassName})`
      } : {
        columns: `:not(.${excludeFromExportClassName})`
      }
    );
  }

  render() {
    return (
      <div>
        <table
          id={this.tableId}
          className={
            'table table-striped table-bordered ' + (this.props.className || '')
          }
          ref={(el) => (this.el = el)}
          style={{ width: '100% !important' }}
        />
      </div>
    );
  }
}
